import { IInfrastructureResponse } from '../utils';

export const toInfrastructureTypes = (infrastructure: IInfrastructureResponse[]) => {
  return infrastructure.map(({ category, title }) => ({
    type: category,
    title,
  }));
};
